import React from "react"

import Button from "./Button"


function BlueButton(props) {
    return <Button {...props} />
}

export default BlueButton